export default __webpack_public_path__ + "static/media/about-page-img.1ef828a5.jpg";